import { observer } from 'mobx-react';
import React, { useMemo } from 'react';

import ArrowRightAltOutlinedIcon from '@mui/icons-material/ArrowRightAltOutlined';
import { Button, Link } from '@mui/material';

import useStores from 'hooks/use-stores';
import { ALLOWED_TYPES } from 'pages/Search/components/Database/components/BulletinTypes/constants';
import BulletinWidget from 'pages/Search/components/Database/components/BulletinWidget';

import useStyles from './styles';

interface Props {
    className?: string;
}

const BulletinTypes: React.FC<Props> = ({ className }) => {
    const { classes, cx } = useStyles();
    const { statsStore } = useStores();

    const bulletins = useMemo(() => {
        return Object.entries(statsStore.types)
            .filter(([key]) => ALLOWED_TYPES.includes(key))
            .map(([key, value]) => {
                const { displayName = '', count = 0 } = value as { displayName?: string; count?: number };
                return {
                    type: key,
                    name: displayName.replace(/^@.+\s*?\((.+)\)$/g, '$1'),
                    count
                };
            });
    }, [statsStore.types]);

    return (
        <div className={cx(classes.container, className)}>
            <div className={classes.header}>
                <p className={classes.title}>
                    {'Top security '}
                    <Link href="/search/vendors" target="_blank">
                        {'vendors'}
                    </Link>
                    {', '}
                    <Link href="/blog" target="_blank">
                        {'articles'}
                    </Link>
                    {' and '}
                    <Link href="/glossary" target="_blank">
                        {'databases'}
                    </Link>
                </p>
                <Button
                    endIcon={<ArrowRightAltOutlinedIcon viewBox="2 2 20 20" />}
                    variant="outlined"
                    color="inherit"
                    className={classes.button}
                    href={'/stats'}
                    target={'_blank'}
                >
                    {'Show all'}
                </Button>
            </div>
            <div className={classes.bulletins}>
                {bulletins.map(({ type, name, count }) => (
                    <BulletinWidget key={type} type={type} name={name} count={count} className={classes.bulletin} />
                ))}
            </div>
        </div>
    );
};

export default observer(BulletinTypes);
